var map = {
	"./de/btn-detail.png": "3RXJ",
	"./en/btn-detail.png": "Lpjm",
	"./es/btn-detail.png": "cydg",
	"./fr/btn-detail.png": "wtZ5",
	"./ja/btn-detail.png": "ef0Z",
	"./ko/btn-detail.png": "MQUV",
	"./pt/btn-detail.png": "xqU7",
	"./ru/btn-detail.png": "AGu0",
	"./th/btn-detail.png": "bXP+",
	"./zh-Hant/btn-detail.png": "PKNt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y54G";